import { IAccountManagerDetailsState } from "../Models/IShared";

export const initialAccountManagerDetailsState: IAccountManagerDetailsState = {
    email: "",
    id: null,
    name: "",
    phoneNumber: ""
}